import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { noop } from "lodash-es";

import { FixedPositionedDropdown } from "src/base-components/FixedPositionedDropDown";
import { Pill } from "src/base-components/Pill";
import { FeatureQueryStatus } from "src/clients/features-control/api";
import { DropdownItem } from "src/design-system/Dropdown";
import { useModal } from "src/design-system/Modal";
import { QueryToggleConfirmationModal } from "src/featureCatalogue/Queries/QueryToggleConfirmationModal";

type StatusDropdownProps = {
  value: FeatureQueryStatus;
  disabled?: boolean;
};

type Status = {
  key: FeatureQueryStatus;
  value: string;
};

const STATUSES: Status[] = [
  {
    key: FeatureQueryStatus.ACTIVE,
    value: "Active",
  },
  {
    key: FeatureQueryStatus.INACTIVE,
    value: "Inactive",
  },
];

export const StatusDropdown: React.FC<StatusDropdownProps> = ({
  value,
  disabled = false,
}) => {
  const { openModal: openConfirmationModal, isOpen, closeModal } = useModal();
  return (
    <>
      <FixedPositionedDropdown<string, FeatureQueryStatus>
        buttonClassName="border-0 ring-0 focus:ring-0 "
        disabled={disabled}
        elements={STATUSES}
        placement="bottom start"
        renderButtonValue={() => {
          const status = STATUSES.find((s) => s.key === value);
          return <StatusBadge status={value} value={status?.value ?? ""} />;
        }}
        renderValue={({ value: displayValue, selected }) => (
          <DropdownItem
            data-loc={`status-${displayValue.toLowerCase()}`}
            data-selected={selected || undefined}
          >
            <span>{displayValue}</span>
          </DropdownItem>
        )}
        selected={value}
        onSelect={openConfirmationModal}
      />
      <QueryToggleConfirmationModal
        closeModal={closeModal}
        isActive={value === FeatureQueryStatus.ACTIVE}
        isOpen={isOpen}
        onConfirm={noop}
      />
    </>
  );
};

const StatusBadge: React.FC<{
  status: FeatureQueryStatus;
  value: string;
}> = ({ status, value }) => {
  const isActive = status === FeatureQueryStatus.ACTIVE;

  return (
    <Pill size="sm" variant={isActive ? "green" : "gray"}>
      <Pill.Text>{value}</Pill.Text>
      <Pill.Icon
        color={isActive ? "text-green-500" : "text-gray-500"}
        icon={faChevronDown}
        size="xs"
      />
    </Pill>
  );
};
